import {
  ResponsesFundWithdrawAssetsResponse,
  ResponsesFundWithdrawDateQuotationResponse,
  ResponsesFundWithdrawTaxSimulatorResponse,
} from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

import {
  FundWithdrawAssetNormalized,
  FundWithdrawDateQuotationNormalized,
  FundWithdrawTaxSimulateNormalized,
} from '../types';

export const normalizeFundsWithdrawGetFundAsset = (
  data: ResponsesFundWithdrawAssetsResponse
): FundWithdrawAssetNormalized => {
  if (!data.funds || data.funds.length === 0) {
    throw new Error('No fund found');
  }

  const fund = data.funds[0];

  return {
    portfolioId: data.portfolioId,
    portfolioName: data.portfolioName,
    fund: {
      ...fund,
      fundNameNormalized: fund.fundName || '--',
      grossTotalValueNormalized: Utils.Mask.Money(fund.grossTotal),
      pendingRedemptionValueNormalized: Utils.Mask.Money(fund.pendingRedemption),
      cutoffTimeNormalized: fund.cutoffTime || '--',
      minimumBalanceNormalized: Utils.Mask.Money(fund.minimumBalance),
      minimumTransactionNormalized: Utils.Mask.Money(fund.minimumTransaction),
      quotationAndLiquidationNormalized: fund.quotationAndLiquidation || '--',
      earlyRedemptionDescriptionNormalized: fund.earlyRedemptionDescription || '',
      quotationDateFormatted: Utils.Mask.DateFormat(fund.quotationDate, 'dd/MM/yyyy'),
    },
  };
};

export const normalizeFundsWithdrawSimulateTax = (
  data: ResponsesFundWithdrawTaxSimulatorResponse
): FundWithdrawTaxSimulateNormalized => {
  const normalizeMoneyIfAvailable = (value: number) => {
    return data.isBalanceAvailable ? Utils.Mask.Money(value) : '--';
  };

  return {
    ...data,
    irValueNormalized: normalizeMoneyIfAvailable(data.irValue),
    iofValueNormalized: normalizeMoneyIfAvailable(data.iofValue),
    penaltyValueNormalized: normalizeMoneyIfAvailable(data.penaltyValue),
    liquidityValueNormalized: normalizeMoneyIfAvailable(data.liquidityValue),
  };
};

export const normalizeFundsWithdrawDateQuotation = (
  data: ResponsesFundWithdrawDateQuotationResponse
): FundWithdrawDateQuotationNormalized => {
  return {
    ...data,
    isValid: true,
    movimentDateFormatted: Utils.Mask.DateFormat(data.movimentDate, 'dd/MM/yyyy'),
    quotationDateFormatted: Utils.Mask.DateFormat(data.quotationDate, 'dd/MM/yyyy'),
    liquidityDateFormatted: Utils.Mask.DateFormat(data.liquidityDate, 'dd/MM/yyyy'),
  };
};
